let ES6Promise = require('es6-promise');
ES6Promise.polyfill();

export const initPolyfill = () => {
  // Some polyfills for sh***y IE
  if (!String.prototype.startsWith) {
    // eslint-disable-next-line
    String.prototype.startsWith = function(search: string, pos?: number) {
      return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    };
  }

  if (!String.prototype.endsWith) {
    // eslint-disable-next-line
    String.prototype.endsWith = function(search: string, thisLen?: number) {
      if (thisLen === undefined || thisLen > this.length) {
        thisLen = this.length;
      }
      return this.substring(thisLen - search.length, thisLen) === search;
    };
  }

  if (!Array.prototype.find) {
    // eslint-disable-next-line
    Array.prototype.find = function(callback: Function) {
      for (let e = 0; e < this.length; e++) {
        if (callback(this[e])) {
          return this[e];
        }
      }
    };
  }
};
